import React, { useState } from 'react';

const CryptoDepositModal = ({ isOpen, onClose, cryptoType }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyClick = async () => {
    // Usar la dirección de la API si está disponible
    const address = cryptoType?.address || document.querySelector('.ppt_address_qr').textContent;
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset después de 2 segundos
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };

  if (!isOpen) return null;
  return (
    <div className="modal_overlay" onClick={(e) => {
      if (e.target.className === 'modal_overlay') onClose();
    }}>
      <div className="modal_content">
        <div className="modal_content_header">
          <span onClick={onClose} className="modal_content_header_close"></span>
        </div>
        <div className="modal_content_body text-center">
          <h3 className="ppt_form_title mb-3">
            Deposit
            <img
              src={process.env.PUBLIC_URL + cryptoType.image}
              alt={cryptoType.name}
              style={{ width: '32px', marginLeft: '8px' }}
            />
          </h3>
          <p className="d-block col-lg-10 mx-lg-auto">
            <strong className="text-danger">
              <img
                src={process.env.PUBLIC_URL + '/assets/img/icon_warning_red.svg'}
                alt=""
                style={{ width: '14px', transform: 'translateY(-1px)' }}
              /> Important:
            </strong> Deposit {cryptoType.name} only to this address.
            Sending any other asset may result in permanent loss.
          </p>
          {/* Usar el QR de la API si está disponible */}
          <img
            src={cryptoType.qrCode || process.env.PUBLIC_URL + '/assets/img/qr.jpg'}
            alt=""
          />
          <span className="ppt_address_qr my-3 d-block col-lg-8 mx-auto" style={{ wordBreak: 'break-all' }}>
            {cryptoType.address || '0xd58B9Ae085F725Ba97B8C30C0d0aeC0ECa47146b'}
          </span>
          <span className='ppt_btn_primary alt mb-3 d-inline-flex align-items-center gap-2' onClick={handleCopyClick}>
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_copy.svg'} alt="" />
            {copied ? 'Copied!' : 'Copy Address'}
          </span>
          <p className="mb-0">
            <strong>Network:</strong> {cryptoType.name}
            <img
              src={process.env.PUBLIC_URL + cryptoType.image}
              alt={cryptoType.name}
              style={{ width: '21px', marginLeft: '8px', transform: 'translateY(-1px)' }}
            />
          </p>
          <p><strong>Processing Time:</strong> 14min.</p>
        </div>
      </div>
    </div>
  );
};

export default CryptoDepositModal;